/* eslint-disable react/prop-types */
import { Box, Text } from "@chakra-ui/react";

import UserInfo from "./UserInfo";

const AuthenticatedUser = ({ userData }) => {
  return (
    <Box>
      <Text fontSize="lg" fontWeight={600} color="white">
        Hi, {userData.displayName}
      </Text>
      <UserInfo>
        {userData?.tribalDisplay?.map((tribal, index) => (
          <p key={index}>{tribal}</p>
        ))}
      </UserInfo>
    </Box>
  );
};

export default AuthenticatedUser;
